module.exports = require('./helpers/bundle-url').getBundleURL('kmWVw') + "logo-dark.eefe0b7f.svg";